<template>
  <ExternalQueryList
      headline="Job Regions"
      endpoint="/api/v2/content-job-regions"
      :endpoint-filters="{portal_id: portal.id}"
      :headlines="headlines"
      :filters="filters"
      :can-destroy="() => true"
      :can-update="() => true"
      :checkbox-column-width="2"
      :button-column-width="2"
      @show="contentJobRegion => $router.push(getUrl(contentJobRegion))"
  >
    <template v-slot:default="{ row: contentJobRegion }">
      <td>
        <router-link :to="getUrl(contentJobRegion)">
          {{ contentJobRegion.attributes.name }}
        </router-link>
      </td>
    </template>

    <template v-slot:headline-right>
      <router-link
          class="btn btn-white btn-sm"
          style="margin-top: 4px;"
          :to="'/portals/' + portal.id + '/content/job-regions/create'"
      >
        <i class="fa fa-plus"></i> Create
      </router-link>
    </template>
  </ExternalQueryList>
</template>

<script>
import ExternalQueryList from '../../../Panels/Lists/ExternalQuery'

export default {
  components: {ExternalQueryList},

  props: {
    portal: {
      required: true
    }
  },

  computed: {
    headlines() {
      return [
        {width: 20, text: 'Name'},
      ]
    },

    filters() {
      return [
        [
          {
            width: 20,
            widget: 'text',
            name: 'search',
            placeholder: 'Search...'
          },
          {
            width: 4,
            widget: 'submit'
          }
        ]
      ]
    }
  },

  methods: {
    getUrl(contentJobRegion) {
      return '/portals/' + this.portal.id + '/content/job-regions/' + contentJobRegion.id + '/edit'
    }
  }
}
</script>
